import React from "react";

function Foot() {
  return (
    <>
      <div className="foot">
        <div className="logo">
          <img src="./images/flogo.png" alt="" />
        </div>
        <div className="info">
          <div className="d1">
            <div className="contact_box">
              <p className="p1">Contact Information</p>
              <div className="text">
                <div className="item">
                  <p className="pt">Email</p>
                  <p className="pd">noah.liu@wekruit.com</p>
                </div>
                {/* <div className="item">
                  <p className="pt">Phone</p>
                  <p className="pd">(XXX) XXX-XXXX</p>
                </div> */}
                <div className="item">
                  <p className="pt">Address</p>
                  <p className="pd">1360 W 24th st, Los Angeles, CA, 90007</p>
                </div>
              </div>
            </div>
            <div className="additional_box">
              {/* <p className="p1">Additional Links</p>
              <div className="links">
                <a href="">FAQ</a>
                <a href="">Careers</a>
                <a href="">Blog</a> */}
              {/* </div> */}
            </div>
            <div className="media_box">
              <p className="p1">Social Media</p>
              <div className="icons">
                <a href="https://www.linkedin.com/company/wekruit/">
                  <img src="./images/icon1.svg" alt="Linkedin" />
                </a>
                <a href="https://linktr.ee/wekruit">
                  <img src="./images/icon2.svg" alt="Disord" />
                </a>
                <a href="https://www.instagram.com/wekruit/#">
                  <img src="./images/icon3.svg" alt="Ins" />
                </a>
                <a href="https://www.xiaohongshu.com/user/profile/5a2988b04eacab2eb292a497?xsec_token=YBnhCyyK2SBZLMpCO-swyWkaMM7sknzGzTr6AoA9PnqUU=&xsec_source=app_share&xhsshare=CopyLink&appuid=5a2988b04eacab2eb292a497&apptime=1743410800&share_id=5fb2c546baea4ccdbf4cd3aa07ad5cdc">
                  <img src="./images/icon4.svg" alt="RedNotes" />
                </a>
              </div>
            </div>
          </div>
          <div className="d2">
            <p className="p1">@ 2025 WeKurit Design</p>
            <div className="links">
              <a href="https://wekruit-case-interview.web.app/dashboard/terms">
                Terms of Service
              </a>
              <span></span>
              <a href="https://wekruit-case-interview.web.app/dashboard/privacy">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="foot_phone">
        <div className="d1">
          <div className="logo">
            <img src="./images/flogo.png" alt="" />
          </div>
          <div className="contact_box">
            <p className="p1">Contact Information</p>
            <div className="text">
              <div className="item">
                <p className="pt">Email</p>
                <p className="pd">admin1@wekruit.com</p>
              </div>
              <div className="item">
                {/* <p className="pt">Phone</p>
                <p className="pd">(XXX) XXX-XXXX</p> */}
              </div>
              <div className="item">
                <p className="pt">Address</p>
                <p className="pd">1360 W 24th st, Los Angeles, CA, 90007</p>
              </div>
            </div>
          </div>
        </div>
        <div className="d2">
          <div className="additional_box">
            {/* <p className="p1">Additional Links</p>
            <div className="links">
              <a href="">FAQ</a>
              <a href="">Careers</a>
              <a href="">Blog</a>
            </div> */}
          </div>

          <div className="media_box">
            <p className="p1">Social Media</p>
            <div className="icons">
              <a href="https://www.linkedin.com/company/wekruit/">
                <img src="./images/icon1.svg" alt="Linkedin" />
              </a>
              <a href="https://linktr.ee/wekruit">
                <img src="./images/icon2.svg" alt="Disord" />
              </a>
              <a href="https://www.instagram.com/wekruit/#">
                <img src="./images/icon3.svg" alt="Ins" />
              </a>
              <a href="https://www.xiaohongshu.com/user/profile/5a2988b04eacab2eb292a497?xsec_token=YBnhCyyK2SBZLMpCO-swyWkaMM7sknzGzTr6AoA9PnqUU=&xsec_source=app_share&xhsshare=CopyLink&appuid=5a2988b04eacab2eb292a497&apptime=1743410800&share_id=5fb2c546baea4ccdbf4cd3aa07ad5cdc">
                <img src="./images/icon4.svg" alt="RedNotes" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Foot;
